import * as React from 'react';
import { styled } from '@mui/material';

type IconProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & {
	padLeft?: boolean;
	padRight?: boolean;
};

const Icon: React.FC<IconProps> = props => <span {...props} />;

export const CerebroIcon = styled(Icon, {
	shouldForwardProp: prop => prop !== 'padLeft' && prop !== 'padRight' && prop !== 'sx',
})(({ padLeft = false, padRight = false, theme }) => ({
	display: 'inline-block',
	...(padLeft ? { paddingLeft: theme.spacing(1) } : {}),
	...(padRight ? { paddingRight: theme.spacing(1) } : {}),
}));
